export default __webpack_public_path__ + "static/media/notLogsImg.8960dd42.svg";